module.exports = __webpack_public_path__ + "static/media/Upload.bc1f4344.svg";